// components/article.js
import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import ViewMoreArticlesFunc from "./ViewMoreArticles";
import { api } from "../lib/api";

function stripHtml(html) {
  const div = document.createElement("div");
  div.innerHTML = html || "";
  return div.textContent || div.innerText || "";
}

export default function Article({ websiteId, section, basePath }) {
  const { itemSlug } = useParams();
  const [item, setItem] = useState(null);
  const [siblings, setSiblings] = useState([]);
  const [state, setState] = useState({ loading: true, error: null });

  useEffect(() => {
    (async () => {
      try {
        // One-shot resolver: website + section slug + item slug
        const { item: resolvedItem } = await api.resolveBySlugs(websiteId, section.slug, itemSlug);
        setItem(resolvedItem);

        // Fetch more items from the same section (for “Fler nyheter”)
        const list = await api.itemsBySection(section._id);
        setSiblings(list || []);
        setState({ loading: false, error: null });
      } catch (e) {
        setState({ loading: false, error: e.message || "Network error" });
      }
    })();
  }, [websiteId, section?.slug, section?._id, itemSlug]);

  const viewMoreArticles = useMemo(() => {
    if (!item || !siblings?.length) return [];
    const filtered = siblings.filter((x) => x.link !== item.link);
    return filtered.slice(0, 3).map(x => ({
      name: x.name,
      link: x.link,
      date: x.updatedAt ? new Date(x.updatedAt).toLocaleDateString("sv-SE") : "",
      content: (item && item.content) ? stripHtml(item.content) : "" // quick excerpt from current item
    }));
  }, [item, siblings]);

  if (state.loading) return <div className="p-8">Laddar artikel…</div>;
  if (state.error) return <div className="p-8 text-red-600">Fel: {state.error}</div>;
  if (!item) return <div className="p-8">Artikeln hittades inte.</div>;

  return (
    <section>
      <div className="p-8 min-h-[50vh] w-fit mx-auto lg:pb-16 lg:px-48 portrait:min-h-[57vh]">
        <h2 className="text-2xl font-bold mb-3">{item.name}</h2>
        <div dangerouslySetInnerHTML={{ __html: item.content || "" }} />
      </div>
      <ViewMoreArticlesFunc viewMoreArticles={viewMoreArticles} path={`${basePath}`} />
    </section>
  );
}
